<template>
	<div class="home">
		<div class="jumbotron">
			<div class="container">
				<img class="img-fluid w-25" src="../assets/logo2.png">
			</div>
		</div>

		<div class="container">
			<div class="row">
				<div class="col-sm-4">
					<div class="card mb-4">
						<div class="card-body">
							<h5 class="card-title">Zarada</h5>
							<h6 class="card-subtitle mb-2 text-muted">Ukupan priliv</h6>
							<p class="card-text display-4">{{totalIncome | decimal}}</p>
						</div>
					</div>
					<div class="card">
						<div class="card-body">
							<h5 class="card-title">Priliv u poslednjih 365 dana</h5>
							<p class="card-text display-4">{{rolling365Income | decimal}}</p>
						</div>
					</div>
				</div>
				<div class="col-sm-4">
					<div class="card">
						<div class="card-header">Priliv po godini</div>
						<ul class="list-group list-group-flush">
							<li class="list-group-item" v-for="item in incomePerYear"><strong>{{item.year}}</strong> {{item.income | decimal}}</li>
						</ul>
					</div>
				</div>
				<div class="col-sm-4">
					<div class="card">
						<div class="card-body">
							<h5 class="card-title">Dugovanja</h5>
							<p class="card-text">{{totalDebt | decimal}}</p>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { invoiceStore } from '../stores/invoices';
import moment from 'moment';
import _ from 'lodash';

export default {
	name: 'home',

	data() {
		return {
			invoiceState: invoiceStore.state
		};
	},

	computed: {
		totalIncome() {
			return this.invoiceState.invoices.filter(invoice => invoice.type === 'invoice').reduce((total, invoice) => (invoice.payments || []).reduce((total, payment) => payment.amount + total, 0.0) + total, 0.0);
		},

		rolling365Income() {
			let offsetDate = moment().subtract(365, 'days');

			return this.invoiceState.invoices
				.filter(invoice => invoice.type === 'invoice')
				.filter(invoice => moment(invoice.issueDate.toDate()).isAfter(offsetDate))
				.reduce((total, invoice) => (invoice.payments || []).reduce((total, payment) => payment.amount + total, 0.0) + total, 0.0);
		},

		incomePerYear() {
			return _(this.invoiceState.invoices
				.filter(invoice => invoice.type === 'invoice'))
				.groupBy(invoice => moment(invoice.issueDate.toDate()).year())
				.map((invoices, year) => ({
					year: year,
					income: invoices.reduce((total, invoice) => (invoice.payments || []).reduce((total, payment) => payment.amount + total, 0.0) + total, 0.0)
				}))
				.orderBy('year', 'desc')
				.value();
		},

		totalDebt() {
			return this.invoiceState.invoices.filter(invoice => invoice.type === 'invoice').reduce((total, invoice) => (invoice.total - (invoice.payments || []).reduce((total, payment) => payment.amount + total, 0.0)) + total, 0.0);
		}
	}
};
</script>

<style scoped>
.jumbotron {
	text-align: center;
}
/*
.home {
	background-image: url(https://source.unsplash.com/category/nature/daily);
	background-repeat: no-repeat;
    background-position: center center;
    background-size: cover;
}
*/
</style>



// WEBPACK FOOTER //
// Home.vue?d0e438c6